import useValidationModal from '@/@core/components/base-modal/hooks/useValidationModal'
import tagModel from '@/models/tag/tag-list'
import router from '@/router'
import store from '@/store'
import useFlatPickr from '@/utils/hooks/useFlatPickr'
import {
  getCurrentInstance,
  onBeforeMount,
  reactive,
  ref,
} from '@vue/composition-api'

export default function useTagsInfo() {
  const vm = getCurrentInstance().proxy

  const { fetchTagInfo, createTag, editTag } = tagModel()

  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal()

  const {
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    resolveDateObject,
    resolveDate,
    resolveTime,
  } = useFlatPickr()

  const tagsInfoData = reactive({
    Seq: 0,
    Group: '',
    GroupKey: '',
    Reference: '',
    TagsName: '',
    StoreTagsName: '',
    StringValue: '',
    IntValue: '',
    DecimalValue: '',
    isBoolValue: false,
    ExtraPayload: '',
  })

  const isEdit = ref(false)

  const onInputTagName = textStr => {
    const num = textStr
      .replace(/[^a-zA-Z0-9-\s]/g, '')
      .substring(0, 200)
      .toLowerCase()
    return num.split(' ').join('-')
  }

  const fetchTagInfoFunc = () => {
    window.$loading(true)
    fetchTagInfo.payload.Tag = tagsInfoData.TagsName

    store
      .dispatch('api/apiRequest', fetchTagInfo)
      .then(response => {
        const respData = response.data.tag

        if (Object.keys(respData).length > 0) {
          tagsInfoData.Seq = respData.seq
          tagsInfoData.Group = respData.group
          tagsInfoData.GroupKey = respData.group_key
          tagsInfoData.Reference = respData.tag_ref
          tagsInfoData.StoreTagsName = respData.tag
          tagsInfoData.TagsName = respData.tag
          tagsInfoData.StringValue = respData.data.string_val
          tagsInfoData.IntValue = respData.data.int_val
          tagsInfoData.DecimalValue = respData.data.decimal_val
          tagsInfoData.isBoolValue = respData.data.bool_val
          tagsInfoData.ExtraPayload = respData.data.extra_data
          validFrom.date = respData.data.datetime_val
            ? resolveDate(respData.data.datetime_val)
            : null
          validFrom.time = respData.data.datetime_val
            ? resolveTime(respData.data.datetime_val)
            : null
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  const checkFormCreateOrEdit = () => {
    isEdit.value = false
    if (router.currentRoute.params.ref) {
      isEdit.value = true
      tagsInfoData.TagsName = router.currentRoute.params.ref
    }
  }

  const onSubmitForm = () => {
    window.$loading(true)
    const payload = {
      String_Val: tagsInfoData.StringValue || null,
      Int_Val: tagsInfoData.IntValue || null,
      Decimal_Val: tagsInfoData.DecimalValue || null,
      Bool_Val: tagsInfoData.isBoolValue || false,
      DateTime_Val:
        validFrom.date && validFrom.time ? resolveDateObject(validFrom) : null, // datetime
      Extra_Data: tagsInfoData.ExtraPayload || null,
    }

    createTag.payload = payload
    editTag.payload = payload

    let payloadParam = {}
    if (isEdit.value == true) {
      payloadParam = editTag
      payloadParam.payload.Tag = tagsInfoData.StoreTagsName
      payloadParam.payload.Tag_Name = tagsInfoData.TagsName
    } else {
      payloadParam = createTag
      payloadParam.payload.Tag = tagsInfoData.TagsName
    }

    store
      .dispatch('api/apiRequest', payloadParam)
      .then(response => {
        const respData = response.data.tag

        if (Object.keys(respData).length > 0) {
          router.replace(`/tags/info/${respData.tag}`)
          tagsInfoData.TagsName = respData.tag

          openSuccessModal('ทำรายการสำเร็จ !', null, null, null, () => {
            checkFormCreateOrEdit()
            fetchTagInfoFunc()
          })
        }
      })
      .catch(err => {
        openDefaultErrorModal(err)
      })
      .finally(() => {
        window.$loading(false)
      })
  }

  onBeforeMount(() => {
    checkFormCreateOrEdit()
    if (tagsInfoData.TagsName) {
      fetchTagInfoFunc()
    }
  })

  return {
    tagsInfoData,
    validFrom,
    validThrough,
    flatpickrDateConfig,
    flatpickrTimeConfig,
    onOpenValidFromDatePicker,
    onOpenValidFromTimePicker,
    onOpenValidThroughTimePicker,
    onSelectValidFromDate,
    onSelectValidFromTimePicker,
    onSubmitForm,
    onInputTagName,
  }
}
